import React from 'react';
import { WhatsappLogo } from '@phosphor-icons/react';

const WHATSAPP_NUMBER = '918840804798';
const DEFAULT_MESSAGE = 'Hi, I would like to enquire about a second medical opinion consultation on SecondDoctorOpinion.com';

export default function WhatsAppButton({ message = DEFAULT_MESSAGE }) {
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 px-5 py-3 rounded-full shadow-lg hover:scale-105 transition-transform"
      style={{ backgroundColor: '#25D366', color: 'white' }}
      data-testid="whatsapp-floating-button"
      aria-label="Chat with us on WhatsApp"
    >
      <WhatsappLogo size={28} weight="fill" />
      <span className="font-medium hidden sm:inline">Chat on WhatsApp</span>
    </a>
  );
}

export { WHATSAPP_NUMBER };
